var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-w-full gl-flex-wrap sm:gl-flex-nowrap"},[_vm._t("upstream"),_vm._v(" "),_vm._t("main"),_vm._v(" "),_vm._t("downstream")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }